import { findParentNodeClosestToPos } from '@tiptap/core';
import { TIPTAP_COLLAPSIBLE_LIST_TYPE } from 'ricos-content';
import type { PluginToolbarConfig } from 'ricos-types';
import { PLUGIN_TOOLBAR_BUTTON_ID } from 'wix-rich-content-editor-common';

import { collapsibleModals } from './consts';
import type { SettingsProps } from './modals/SettingsModals';
import CollapsibleListSettings from './modals/SettingsModals';

export const getToolbarButtons: PluginToolbarConfig['getButtons'] = (config, services) => {
  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SETTINGS,
      modal: {
        Component: CollapsibleListSettings,
        id: collapsibleModals.settings,
      },
      command: ({ isMobile, attributes: { selectedNode } }) => {
        const componentProps: SettingsProps = {
          nodeId: selectedNode.attrs.id,
          isQapageDataEnabled: !!config?.isQapageData,
        };

        services.modals.openModal(collapsibleModals.settings, {
          componentProps,
          positioning: { placement: 'right' },
          layout: isMobile ? 'fullscreen' : 'drawer',
        });
      },
      attributes: {
        selectedNode: selectedNodeResolver,
      },
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE,
      attributes: {
        selectedNode: selectedNodeResolver,
      },
    },
  ];
};

const selectedNodeResolver = {
  id: 'selectedNode',
  resolve: (_, __, editor) => {
    const { selection } = editor?.state || {};
    return findParentNodeClosestToPos(
      selection.$to,
      node => node?.type?.name === TIPTAP_COLLAPSIBLE_LIST_TYPE
    )?.node;
  },
};
